import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import {
  CreatePersonInput,
  CreatePersonOutput,
  Firma,
  GetPersonOutput,
  GetPersonsInput,
  GetPersonsOutput,
  UpdatePersonInput,
  UpdatePersonOutput,
} from './person-api.types';
import { catchError, firstValueFrom, Observable, of } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({ providedIn: 'root' })
export class PersonApiService {
  private resource = `${environment.api.avs}/spindperson`;

  constructor(
    private httpClient: HttpClient,
    private message: NzMessageService,
  ) {}

  getAllPersons(input: GetPersonsInput): Observable<GetPersonsOutput> {
    const url = `${this.resource}`;

    const params = new HttpParams({ fromObject: input });

    return this.httpClient
      .get<GetPersonsOutput>(url, {
        params: params,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of([]); // Return empty array instead of throwing an 404 error
          } else {
            this.message.error(
              'Etwas beim Laden der Personen ist schiefgelaufen',
            );
            return of([]);
          }
        }),
      );
  }

  createPerson(input: CreatePersonInput): Observable<CreatePersonOutput> {
    const url = `${this.resource}`;

    return this.httpClient.post<CreatePersonOutput>(url, input);
  }

  getPerson(id: number): Observable<GetPersonOutput> {
    const url = `${this.resource}/${id}`;
    return this.httpClient.get<GetPersonOutput>(url);
  }

  updatePerson(
    id: number,
    personType: number,
    input: Partial<UpdatePersonInput>,
  ): Promise<UpdatePersonOutput> {
    if (personType !== 5) {
      delete input.name;
      delete input.vorname;
      delete input.geschlecht;
      delete input.firmaId;
    }

    const url = `${this.resource}/${id}`;
    return firstValueFrom(
      this.httpClient.patch<UpdatePersonOutput>(url, input),
    );
  }

  searchPerson(input: GetPersonsInput): Observable<GetPersonsOutput> {
    const url = `${this.resource}`;
    const params = new HttpParams({ fromObject: input });

    return this.httpClient.get<GetPersonsOutput>(url, {
      params,
    });
  }

  getAllCompanies(): Observable<Firma[]> {
    const url = `${environment.api.avs}/Firmen`;

    return this.httpClient.get<Firma[]>(url);
  }
}
